module.exports = __webpack_public_path__ + "media/images/icons/SVG/003-553f94767e1db570d1cac291ec433c6b.svg";